export default {
  isImage(url) {
    return url.match(/\.(jpeg|jpg|gif|png|webp)$/) != null;
  },
  isVideo(url) {
    return url.match(/\.(mp4|avi)$/) != null;
  },
};
